import React from 'react';
import { LoaderContainer, LoaderSpinner } from './styled';

interface LoaderProps {
  loading?: boolean;
  pageLoader?: boolean;
  endless?: boolean;
  children?: React.ReactNode;
}

export const Loader: React.FC<LoaderProps> = ({
  loading,
  children,
  pageLoader,
  endless
}) => {
  const spinner = (
    <LoaderContainer $pageLoader={pageLoader} $endless={endless}>
      <LoaderSpinner />
    </LoaderContainer>
  );

  return <>{(loading && spinner) || children}</>;
};
